import { createSvgIcon } from '@mui/material/utils';

export const BookmarkIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none">
    <path
      d="M23.619 2.66667H8.38095C6.70476 2.66667 5.34857 4.13334 5.34857 5.92593L5.33333 32L16 25.4815L26.6667 32V5.92593C26.6667 4.13334 25.2952 2.66667 23.619 2.66667Z"
      fill="currentColor"
    />
  </svg>,
  'Bookmark',
);
